module.exports = __webpack_public_path__ + "static/media/close.eba0eb53.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/close.png
// module id = 95
// module chunks = 0 1